import { useState } from "react";
import { MessageSquare, Send, Copy, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { siteData } from "../data/mock";

export const TextToBookSection = () => {
  const [copied, setCopied] = useState(false);

  const messageTemplate = `Hi Dr. Kang, I'd like to book an appointment for [Name] at your [Location] office. My preferred time is [Date/Time].`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(messageTemplate);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const handleSMS = () => {
    const encodedMessage = encodeURIComponent(messageTemplate);
    window.location.href = `sms:${siteData.clinic.smsNumber}?body=${encodedMessage}`;
  };

  return (
    <section
      id="text-to-book"
      aria-labelledby="text-to-book-heading"
      className="py-20 lg:py-28 bg-[#232323]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-stone-700 flex items-center justify-center mx-auto mb-6">
          <MessageSquare className="w-7 h-7 text-white" aria-hidden="true" />
        </div>

        <h2
          id="text-to-book-heading"
          className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white mb-4 tracking-tight"
          style={{ fontFamily: '"Cormorant Garamond", serif' }}
        >
          Text to Book
        </h2>

        <p className="text-lg text-stone-400 mb-10">
          Need more time options? Text Dr. Kang directly for faster booking!
        </p>

        <Card className="border-0 shadow-xl rounded-2xl bg-white overflow-hidden">
          <CardContent className="p-8">
            <div className="flex items-center justify-center gap-2 mb-2">
              <MessageSquare className="w-5 h-5 text-[#232323]" aria-hidden="true" />
              <h3 className="text-xl font-semibold text-[#232323]">
                Text Dr. Kang Directly
              </h3>
            </div>
            <p className="text-sm text-stone-500 mb-6">
              The fastest way to schedule your appointment
            </p>

            <div className="mb-6">
              <p className="text-xs text-stone-400 uppercase tracking-wider mb-3">
                Click to copy text template:
              </p>
              <button
                onClick={handleCopy}
                className="relative w-full p-4 bg-stone-50 rounded-xl border-2 border-dashed border-stone-200 hover:border-stone-300 transition-colors text-left group"
                data-testid="copy-template-btn"
              >
                <p className="text-sm text-stone-600 font-mono leading-relaxed pr-8">
                  "{messageTemplate}"
                </p>
                <div className="absolute top-4 right-4 text-stone-400 group-hover:text-stone-600 transition-colors">
                  {copied ? (
                    <Check className="w-5 h-5 text-green-500" />
                  ) : (
                    <Copy className="w-5 h-5" />
                  )}
                </div>
              </button>
            </div>

            <Button
              onClick={handleSMS}
              className="w-full bg-[#232323] hover:bg-[#353535] text-white rounded-xl h-14 text-base font-medium transition-all duration-200"
              data-testid="open-sms-btn"
            >
              <Send className="w-5 h-5 mr-2" />
              Open SMS App Now
            </Button>

            <p className="text-sm text-stone-400 mt-5">
              or call{" "}
              <a
                href={`tel:${siteData.clinic.smsNumber}`}
                className="font-semibold text-[#232323] hover:underline"
              >
                {siteData.clinic.phone}
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
